export const BASE_URL = "https://admin.neo-constructions.com/api/rest";
export const PAGE_LIMIT = 20;
